const doc = [({"da":({"js":({"merfoto":({"basket":({"basket_item_card":({"index":({"photo":"Foto"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;